import { useNavigate, useLocation, Navigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from 'react';
import { Helmet } from "react-helmet";
import { Toast } from '../components_root/ToastContext';
import { MdEdit } from "react-icons/md";
export const seo = {
    title: "Online Tools & Digital Services | Productivity, SEO & File Conversion",
    description:
        "Explore free and premium online tools including word counters, file converters, favicon generators, SEO analyzers, and text utilities. Improve productivity with powerful digital tools for students, writers, developers, and businesses.",
    keywords:
        "online tools, productivity tools, seo tools, text utilities, file converter, image to pdf, favicon generator, word counter, online utilities, digital tools, website tools",

};
export default function Editer_page() {
    const [text, setText] = useState("");
    const { Toastshow } = Toast();
    const navigate = useNavigate();
    return (
        <div>

            <Helmet>
                <title>{seo.title}</title>
                <meta name="description" content={seo.description} />
                <meta name="keywords" content={seo.keywords} />
                <meta property="og:title" content={seo.title} />
                <meta property="og:description" content={seo.description} />

            </Helmet>
            <div className="button-ui editor cursor shadow "><MdEdit className="icon" /> Editor</div>
            <div className="container_roots">
                <div className="container_size p-3">
                    <div className='post-container'>

                    </div>

                </div>

            </div>



        </div>
    );
}
